import axios from "axios";
import localforage from "localforage";

import config from "@/config";
import cookies from "@/util/cookies";

const api = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
  },
});

const retirarOffline = (pedido) => {
  // Pedido - atualizar id
  localforage.getItem(pedido.uuid).then((ped) => {
    localforage.setItem(pedido.uuid, { ...ped, id: pedido.id, offline: false });
  });

  // Pedidos offline - remover
  localforage.getItem("pedidos").then((pedidos) => {
    localforage.setItem(
      "pedidos",
      pedidos.filter((ped) => ped.uuid !== pedido.uuid)
    );
  });

  // Lista de pedidos - atualizar
  const url = "/api/pedidos/listar?rodada_id=" + pedido.rodada_id;
  localforage.getItem(url).then((pedidosLista) => {
    const found = pedidosLista.pedidos.find((ped) => ped.uuid === pedido.uuid);
    if (found) {
      localforage.setItem(url, {
        ...pedidosLista,
        pedidos: pedidosLista.pedidos.map((ped) =>
          ped.uuid === pedido.uuid
            ? { ...ped, id: pedido.id, offline: false }
            : ped
        ),
      });
    } else {
      localforage.setItem(url, {
        ...pedidosLista,
        pedidos: [{ ...mapPedidoLista(pedido), offline: false }].concat(
          pedidosLista.pedidos
        ),
      });
    }
  });
};

export const salvar = (pedido) => {
  return api
    .post("/api/pedidos/salvar", pedido, {
      headers: { Authorization: "Bearer " + cookies.get("api_token") },
    })
    .then((result) => {
      retirarOffline({ ...pedido, id: result.data.id });
      return result;
    });
};

export const atualizar = (pedido) => {
  return api
    .post("/api/pedidos/" + pedido.id + "/atualizar", pedido, {
      headers: { Authorization: "Bearer " + cookies.get("api_token") },
    })
    .then((result) => {
      retirarOffline(pedido);
      return result;
    });
};

const cache = [
  "api/produtos/buscar",
  "/api/categorias",
  "/api/fornecedores/listar/loja",
  "/api/banners/ativos",
  "/api/produtos/listar",
  "/api/tamanhos",
  "/api/cores",
  "/api/rodadas/listar",
  "/api/fornecedores",
  "/api/notificacoes/listar",
  // Pedidos
  "/api/pedidos/listar",
  "/api/pedidos/data",
  "/api/pedidos/clientes",
  "/api/pedidos/produtos",
];

const mapPedidoLista = (data) => ({
  id: data.id,
  cliente_id: data.cliente_id,
  cliente_loja_id: data.cliente_loja_id,
  cliente_nome: data.cliente.cliente.nome,
  cnpj: data.cliente.cnpj,
  comissao_percentual: data.comissao_percentual,
  comissao_tipo: data.comissao_tipo,
  comissao_valor: data.comissao_valor,
  created_at: `${data.data} 00:00:00`,
  data: data.data,
  desconto_percentual: data.desconto_percentual,
  desconto_valor: data.desconto_valor,
  entrega: data.entrega,
  forma_pagamento: data.forma_pagamento,
  fornecedor_id: data.fornecedor_id,
  fornecedor_nome: null,
  frete: 0,
  frete_tipo: null,
  frete_valor: 0,
  nome_fantasia: data.cliente.nome_fantasia,
  observacoes: data.observacoes,
  parcelas: null,
  prazo: data.prazo,
  quantidade: data.quantidade,
  razao_social: data.cliente.razao_social,
  representante_id: data.cliente.cliente.representante_id,
  representante_nome: data.cliente.representante_nome,
  rodada_id: data.rodada_id,
  status: 0,
  status_faturamento: 0,
  taxa_percentual: data.taxa_percentual,
  taxa_valor: data.taxa_valor,
  transportadora: data.transportadora,
  transportadora_telefone: data.transportadora_telefone,
  updated_at: `${data.data} 00:00:00`,
  valor_bruto: data.valor_bruto,
  valor_liquido: data.valor_liquido,
  uuid: data.uuid,
  hash: data.hash,
  offline: true,
});

const mapPedido = (
  data // Editar payload
) => ({
  id: data.id,
  cliente_id: data.cliente_id,
  cliente_loja_id: data.cliente_loja_id,
  fornecedor_id: data.fornecedor_id,
  representante_id: data.representante_id,
  rodada_id: data.rodada_id,
  data: data.data,
  entrega: data.entrega,
  valor_bruto: data.valor_bruto,
  valor_liquido: data.valor_liquido,
  forma_pagamento: data.forma_pagamento,
  prazo: data.prazo,
  quantidade: data.quantidade,
  desconto_percentual: data.desconto_percentual,
  desconto_valor: data.desconto_valor,
  taxa_percentual: data.taxa_percentual,
  taxa_valor: data.taxa_valor,
  comissao_percentual: data.comissao_percentual,
  comissao_tipo: data.comissao_tipo,
  comissao_valor: data.comissao_valor,
  vendedor: data.vendedor,
  observacoes: data.observacoes,
  status: data.status || null,
  status_faturamento: data.status_faturamento || null,
  transportadora: data.transportadora,
  transportadora_telefone: data.transportadora_telefone,
  uuid: data.uuid,
  hash: data.hash,
  frete: data.frete || 0,
  frete_tipo: data.frete_tipo || null,
  frete_valor: data.frete_valor || 0,
  parcelas: data.parcelas || null,
  cliente: {
    id: data.cliente.id,
    cliente_id: data.cliente.cliente_id,
    endereco_id: data.cliente.endereco_id,
    cnpj: data.cliente.cnpj,
    ie: data.cliente.ie,
    nome_fantasia: data.cliente.nome_fantasia,
    razao_social: data.cliente.razao_social,
    responsavel_id: data.cliente.responsavel_id,
    logo: data.cliente.logo,
    padrao: data.cliente.padrao,
    cliente: {
      id: data.cliente.cliente.id,
      numero: data.cliente.cliente.numero,
      nome: data.cliente.cliente.nome,
      responsavel_id: data.cliente.cliente.responsavel_id,
      responsavel_nome: data.cliente.cliente.responsavel_nome,
      responsavel_cpf: data.cliente.cliente.responsavel_cpf,
      representante_id: data.cliente.cliente.representante_id,
      fornecedor_id: data.cliente.cliente.fornecedor_id,
      endereco_id: data.cliente.cliente.endereco_id,
      ativo: data.cliente.cliente.ativo,
    },
    endereco: {
      id: data.cliente.endereco.id,
      rua: data.cliente.endereco.rua,
      numero: data.cliente.endereco.numero,
      complemento: data.cliente.endereco.complemento,
      bairro: data.cliente.endereco.bairro,
      cidade_id: data.cliente.endereco.cidade_id,
      estado_id: data.cliente.endereco.estado_id,
      cep: data.cliente.endereco.cep,
      telefone: data.cliente.endereco.telefone,
      celular: data.cliente.endereco.celular,
      email: data.cliente.endereco.email,
      cidade: data.cliente.endereco.cidade,
      estado: data.cliente.endereco.estado,
    },
    representante_nome: data.cliente.representante_nome,
  },
  produtos: data.produtos.map((produto) => ({
    id: produto.id,
    codigo: produto.codigo,
    descricao: produto.descricao,
    valor: produto.valor,
    fornecedor_id: produto.fornecedor_id,
    quantidade: produto.quantidade,
    subtotal: produto.subtotal,
    grade: produto.grade.map((grade) => ({
      cor_id: grade.cor_id,
      cor_nome: grade.cor_nome,
      tamanhos: grade.tamanhos.map((tamanho) => ({
        tamanho_id: tamanho.tamanho_id,
        tamanho_nome: tamanho.tamanho_nome,
        quantidade: tamanho.quantidade,
      })),
    })),
    tamanhos: produto.tamanhos.map((tamanho) => ({
      id: tamanho.id,
      tamanho: tamanho.tamanho,
      peso: tamanho.peso,
      fornecedor_id: tamanho.fornecedor_id,
      tipo: tamanho.tipo,
      pivot: {
        produto_id: tamanho.pivot.produto_id,
        tamanho_id: tamanho.pivot.tamanho_id,
      },
    })),
    cores: produto.cores.map((cor) => ({
      id: cor.id,
      codigo: cor.codigo,
      nome: cor.nome,
      fornecedor_id: cor.fornecedor_id,
      tipo: cor.tipo,
      pivot: {
        produto_id: cor.pivot.produto_id,
        cor_id: cor.pivot.cor_id,
      },
    })),
    observacoes: produto.observacoes,
  })),
});

const fetchPedido = (pedido) => {
  return api
    .get(`/api/pedidos/${pedido.id}/editar`, {
      headers: { Authorization: "Bearer " + cookies.get("api_token") },
    })
    .then(({ data }) => {
      localforage.setItem(pedido.uuid, data.pedido).catch(() => {});
    })
    .catch(() => {});
};

const processHash = async (hashArray) => {
  const list = hashArray.filter((ped) => !!ped.id);

  for (let index = 0; index < list.length; index++) {
    const ped = list[index];
    let pedido;
    try {
      pedido = await localforage.getItem(ped.uuid);
    } finally {
      // Nothing to do here
    }

    if (!pedido || pedido.hash !== ped.hash) {
      try {
        await fetchPedido(ped);
      } finally {
        // Nothing to do here
      }
    }
  }
};

export const saveToCache = (response) => {
  if (response.config.method.toUpperCase() === "GET") {
    const url = response.config.url;
    if (cache.find((str) => url.startsWith(str))) {
      localforage.setItem(url, response.data).catch(() => {});

      if (url.startsWith("/api/pedidos/listar?rodada_id")) {
        const hashArray = response.data.pedidos.map((ped) => ({
          hash: ped.hash,
          id: ped.id,
          uuid: ped.uuid,
        }));

        processHash(hashArray);
      }
    }
  }
};

const loadFromCache = (error) => {
  const url = error.config.url;

  return new Promise((resolve, reject) => {
    localforage
      .getItem(url)
      .then((data) => {
        if (data) {
          resolve({ data });
        } else {
          reject(error);
        }
      })
      .catch(() => reject(error));
  });
};

export const loadPedidoFromCache = (uuid) => {
  return new Promise((resolve, reject) => {
    localforage
      .getItem(uuid)
      .then((pedido) => {
        if (pedido) {
          resolve({ data: { pedido } });
        } else {
          reject();
        }
      })
      .catch(() => reject());
  });
};

export const loadPedidosFromCache = () => {
  return new Promise((resolve, reject) => {
    localforage
      .getItem("pedidos")
      .then((storedData) => {
        const lista = storedData || [];
        resolve(lista);
      })
      .catch((error) => reject(error));
  });
};

const atualizarPedidoCache = (rawData) => {
  const data = JSON.parse(rawData);

  return new Promise((resolve, reject) => {
    localforage
      .getItem("pedidos")
      .then((storedData) => {
        const lista = storedData || [];
        let ok = false;
        const newStoredData = lista.map((ped) => {
          if (data.uuid === ped.uuid) {
            ok = true;
            return mapPedidoLista(data);
          }
          return ped;
        });

        if (!ok) {
          newStoredData.push(mapPedidoLista(data));
        }

        localforage
          .setItem("pedidos", newStoredData)
          .then(() => {
            localforage
              .setItem(data.uuid, mapPedido(data))
              .then(() =>
                resolve({
                  status: 1,
                  msg: !ok
                    ? "Pedido salvo com sucesso!"
                    : "Pedido atualizado com sucesso!",
                })
              )
              .catch((error) => reject(error));
          })
          .catch((error) => reject(error));
      })
      .catch((error) => reject(error));
  });
};

export const processError = (error) => {
  if (error.response) return Promise.reject(error);

  let pedidoId;

  // Cache pedidos
  if (
    error.config.url.startsWith("/api/pedidos/") &&
    error.config.url.endsWith("/editar") &&
    error.config.method.toUpperCase() === "GET"
  ) {
    pedidoId = error.config.url
      .replace("/api/pedidos/", "")
      .replace("/editar", "");

    if (/^[0-9][A-Za-z0-9 -]*$/.test(pedidoId)) {
      return loadPedidoFromCache(error.config.headers.uuid);
    } else if (
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
        pedidoId
      )
    ) {
      return loadPedidoFromCache(pedidoId);
    }
    return Promise.reject(error);
  } else if (error.config.method.toUpperCase() === "GET") {
    return loadFromCache(error);
  }

  // Salvar pedidos offline
  if (
    error.config.method.toUpperCase() === "POST" &&
    error.config.url === "/api/pedidos/salvar"
  ) {
    // return salvarPedidoCache(error.config.data);
    return atualizarPedidoCache(error.config.data);
  }

  // Atualizar pedidos offline
  if (
    error.config.method.toUpperCase() === "POST" &&
    error.config.url.startsWith("/api/pedidos/") &&
    error.config.url.endsWith("/atualizar")
  ) {
    pedidoId = error.config.url
      .replace("/api/pedidos/", "")
      .replace("/atualizar", "");

    if (
      /^[0-9][A-Za-z0-9 -]*$/.test(pedidoId) ||
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
        pedidoId
      )
    ) {
      return atualizarPedidoCache(error.config.data);
    }
    return Promise.reject(error);
  }
  return Promise.reject(error);
};
